import React from 'react';
import './styles/loading-spinner.scss';

export default function LoadingSpinner() {
  return (
    <div type="loading-spinner">
      <div className="loading-spinner" />
    </div>
  );
}
